import { LocalStorageService } from '../services/local-storage.service';
import { KeyString } from '../constants/types';

const getInitials = (fullName: string) => {
	const names = fullName.split(' ');
	let initials = names[0].substring(0, 1).toUpperCase();

	if (names.length > 1) {
		initials += names[names.length - 1].substring(0, 1).toUpperCase();
	}
	return initials;
};

export const getUserAvatar = (fullName: string) => {
	const colors = ["#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#f39c12", "#d35400", "#c0392b"];

	const initials = getInitials(fullName);
	const localStorage = new LocalStorageService();

	let colorSaved = localStorage.getItem('avatarColors');
	let savedColors: KeyString = {};
	if (colorSaved) {
		savedColors = JSON.parse(colorSaved) as KeyString;
	}

	if (!savedColors[initials]) {
		const newColor = colors[Math.floor(Math.random() * colors.length)];
		savedColors[initials] = newColor;

		localStorage.saveItem('avatarColors', JSON.stringify(savedColors));
	}

	return {
		initials,
		color: savedColors[initials],
	};
};